import { FC } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { ExpandedTable } from "../../../ui-kit";

const DictItems: FC = observer(({ record }) => {
  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Наименование",
      dataIndex: "title",
      key: "title",
      className: "align-left",
      width: "95%",
    },
  ];

  return <ExpandedTable columns={columns} data={record.items} />;
});

export default DictItems;
